import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { Product } from "@/models/product.model"
import type { IProduct } from "@/interfaces/api/product.interface"
import { ProductRepository } from "@/repositories/product-repository"
import { useProductsStore } from "@/store/products.store"
import { storeToRefs } from "pinia"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"

export class ProductController extends GenericModelController<
  Product,
  IProduct,
  ProductRepository
> {
  constructor() {
    const productsStore = useProductsStore()
    const { products } = storeToRefs(productsStore)
    const storeFunctionsConfig = {
      collection: products
    }

    super(Product, storeFunctionsConfig, new ProductRepository())
    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(Product, products)
  }
}
